export default __webpack_public_path__ + "cars-guide.84c7d8c8754c04a88117e49a84535413.png";